// extracted by mini-css-extract-plugin
module.exports = {"itemLabel":"messagesimplified_itemLabel__1ap1h"};